import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconBraceletActiveProps } from './IconBraceletActive.types'
import * as Styled from './styles/IconBraceletActive.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBraceletActive: FC<IconBraceletActiveProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBraceletActiveProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconBraceletActiveProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M6.746 12.016a.25.25 0 0 1-.25.25.252.252 0 0 1-.25-.25c0-.141.113-.25.25-.25.14 0 .25.109.25.25Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M6.746 12.016a.25.25 0 0 1-.25.25.252.252 0 0 1-.25-.25c0-.141.113-.25.25-.25.14 0 .25.109.25.25Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M6.547 12.016a.05.05 0 0 1-.05.05.052.052 0 0 1-.052-.05c0-.032.024-.055.051-.055.031 0 .05.023.05.055Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M6.547 12.016a.05.05 0 0 1-.05.05.052.052 0 0 1-.052-.05c0-.032.024-.055.051-.055.031 0 .05.023.05.055ZM12.48 4.54h1.04a3.996 3.996 0 0 1 3.996 3.995v6.992a3.995 3.995 0 0 1-3.996 3.993h-1.04a3.995 3.995 0 0 1-3.996-3.993V8.535A3.996 3.996 0 0 1 12.48 4.54Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M13.223 21.5h-.715A8 8 0 0 1 4.5 13.512v-3a8 8 0 0 1 8-7.989h.715a6.242 6.242 0 0 1 6.262 6.22v6.515a6.246 6.246 0 0 1-6.234 6.25h-.02Zm4.32-9.473h1.934'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconBraceletActive
